export const CyHeader = {
  HeaderButton: "HeaderButton",
} as const;
